import React from 'react';
import { ReactComponent as OperationModel } from '../../assets/ic_operation_model.svg';
import '../../theme/overrides/ative.css';
import '../../theme/overrides/inative.css';

const OperationModelIcon = (state) => (
  <OperationModel className={state ? 'ative' : 'inative'}/>
);

export default OperationModelIcon;
